import { observable, action, runInAction } from "mobx";

import * as LoginAPI from '../../../api/pc/login';
import { getQueryString } from "../../../utils";

export class QysCheckStore {
  @observable qysQrcodeUrl: string = '';
  @observable qysRefreshShown: boolean = false; //刷新二维码

  //二维码有效期
  timer: any = null;
  timerCount = 0;

  //二维码状态轮询
  resultTimer: any = null;
  /**
   *
   * @param visible 显示扫码登录
   */
  @action
  changeQysRefreshShown = (visible: boolean) => {
    this.qysRefreshShown = visible;
  }

  //获取二维码
  @action
  getQrcodeUrl = (isRefresh?: boolean) => {
    const qysCheckAuthId = getQueryString('qysCheckAuthId');
    if (qysCheckAuthId) {
      let params: any = { qysCheckAuthId };
      if (isRefresh) {
        params['refresh'] = 1;
      }
      LoginAPI.queryQysQrUrl(params).then((result: any) => {
        runInAction(() => {
          this.qysQrcodeUrl = result.data?.qysCheckAuthUrl || '';
          // 关闭刷新按钮
          this.qysRefreshShown = false;
          this.timer = setTimeout(() => {
            this.changeQysRefreshShown(true);
            clearInterval(this.timer);
            clearInterval(this.resultTimer);
          }, 1000 * 60 * 5)

          //开始轮询
          clearInterval(this.resultTimer);
          this.QysQrcodePolling({
            tenantKey: result.data?.tenantKey,
            qysCheckAuthId: result.data?.qysCheckAuthId
          });
        });
      })
    }
  }

  /**
   *
   * @param params 轮询请求etoken判断登录状态
   */
  QysQrcodePolling = (params: any) => {
    this.resultTimer = setInterval(() => {
      LoginAPI.checkQysQrStatus(params).then((result: any) => {
        if (result?.data?.loginData?.redirectUrl) {
          clearInterval(this.resultTimer);
          window.location.href = result.data.loginData.redirectUrl;
        }
      });
    }, 1000);
  }

}

const instance = new QysCheckStore();

export default instance;
export type QysCheckStoreType = Pick<QysCheckStore, keyof QysCheckStore>;
